"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs } from 'react/jsx-runtime';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';
import { IconButton } from '../../ui-kit/icon-button.mjs';
import { SvgIcon } from '../SvgIcon/index.mjs';

const redactedToggleButtonRecipe = tv({
  slots: withSlotScopeClasses("redacted-toggle-button", {
    container: "flex items-center px-1.5 py-1",
    button: "h-6 w-6 min-w-[unset] rounded-md text-fg-subtle",
    icon: "w-4 h-4"
  })
});
const RedactedToggleButton = forwardRef(({ className, visible, ...props }, ref) => {
  const { container, button, icon } = redactedToggleButtonRecipe();
  return /* @__PURE__ */ jsx("div", { className: container(), children: /* @__PURE__ */ jsxs(IconButton, { ref, variant: "ghost", colorPalette: "gray", className: button({ className }), ...props, children: [
    /* @__PURE__ */ jsx(SvgIcon, { type: visible ? SvgIconType.Eye : SvgIconType.EyeOff, className: icon() }),
    /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Toggle visibility" })
  ] }) });
});

export { RedactedToggleButton };
